import { gql } from '@apollo/client';

const META_FRAGMENT = gql`
  fragment MetaFragment on PageMetaDto {
    page
    take
    itemCount
    hasNextPage
    hasPreviousPage
    pageCount
  }
`;

export default META_FRAGMENT;
